<section class="h-full flex flex-col">
  <app-modal-header title="Suggest a new transformation" (onClose)="dialogRef.close()" [send]="!error && !success" (onSend)="send()"
                    [processing]="submitting"></app-modal-header>

  <mat-dialog-content>
    <form [formGroup]="suggestionForm">
      <p class="mb-3">
        We value your input and want to hear your ideas for new transformations that you would like to see here.
        Please let us know if you have any specific need and we will do our best to implement it for you.
      </p>

      <div class="dm-input">
        <label for="message">Explain your needs</label>
        <textarea name="message" formControlName="message" rows="5"></textarea>
      </div>
    </form>

    <p class="notice notice-danger" *ngIf="error">
      <i class="fas fa-exclamation-triangle mr-1 text-red-600"></i>
      So ironic... The "report an error" function is currently unavailable. We
      apologize for the inconvenience and promise to get it back up and running ASAP.
    </p>
    <p class="notice notice-success" *ngIf="success">
      <i class="fas fa-check-circle mr-1 text-green-600"></i>
      Feedback sent! We will action it ASAP. Thank you!
    </p>


  </mat-dialog-content>

</section>
